import { Flex, Checkbox } from "@theorgchartdev/storybook";
import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX, kConnectorDataKeys, kKeyToLabelAndDefaultText } from "../Utils";
import { appstr } from "@coreapp/utils/appstr";
import { appcstr } from "@coreapp/utils/appcstr";

const BuildInputs = isOAuth => {
  const keys = isOAuth
    ? [...kConnectorDataKeys["WorkdayAPI"], "workdayhc"]
    : kConnectorDataKeys["Workday"];

  const inputOptions = [];
  for (let key of keys) {
    const option = {};
    option.dataKey = key;
    option.label = appcstr(kKeyToLabelAndDefaultText[key][0]);
    option.placeholder = appcstr(kKeyToLabelAndDefaultText[key][1]);
    option.passwordMask = ["clientID", "clientSecret", "refreshToken", "workdaypstr"].includes(key);
    inputOptions.push(option);
  }
  return inputOptions;
};

export const WorkdaySetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const isOAuth = config?.isOAuth || false;

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      doInputLookup={false}
      inputOptions={BuildInputs(isOAuth)}
      importType={importType}
    >
      <Flex>
        <Checkbox
          id={"is-oauth"}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-workday-oauth-checkbox`}
          label={appstr("Use OAuth2.0 Authentication")}
          size={"medium"}
          checked={isOAuth}
          onChange={() => {
            onChange({ ...config, isOAuth: !isOAuth });
          }}
        />
      </Flex>
    </DataSourceSetupComposite>
  );
};
